module.exports = __webpack_public_path__ + "static/media/gamesFront.58d67b96.jpg";